
import { Link } from "react-router-dom";
import { NavbarLinks } from "./NavbarLinks";
import { NavbarSearch } from "./NavbarSearch";
import { NavbarNotifications } from "./NavbarNotifications";
import { NavbarUserProfile } from "./NavbarUserProfile";

export function Navbar() {
  return (
    <header className="w-full bg-white border-b sticky top-0 z-10">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/">
              <img 
                src="/lovable-uploads/78d52a13-5601-4710-bb55-4900ea8cb3e3.png" 
                alt="Web Star Logo" 
                className="h-12 object-contain"
              />
            </Link>
          </div>

          {/* Navigation */}
          <NavbarLinks />

          {/* Right side - Search, Notifications, User */}
          <div className="flex items-center space-x-2">
            {/* Search */}
            <NavbarSearch />

            {/* Notifications */}
            <NavbarNotifications />

            {/* User */}
            <NavbarUserProfile />
          </div>
        </div>
      </div>
    </header>
  );
}
